import { keys, map, values } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import { LinkCardBlock } from '../link-card-block';

const options = {
  uberEats: {
    description: 'Order From Uber Eats',
    imageSrc: '/static/images/restaurant/uber_eats.png',
    imageAltText: 'Uber Eats Logo',
    defaultLink: 'https://www.ubereats.com/au',
  },
  menulog: {
    description: 'Order From Menulog',
    imageSrc: '/static/images/restaurant/menulog.png',
    imageAltText: 'MenuLog Logo',
    defaultLink: 'https://www.menulog.com.au/',
  },
  doorDash: {
    description: 'Order From Door Dash',
    imageSrc: '/static/images/restaurant/door_dash.png',
    imageAltText: 'Door Dash Logo',
    defaultLink: 'https://www.doordash.com/',
  },
};

const nandosOption = {
  description: 'Order From Nando’s',
  imageSrc: '/static/images/restaurant/nandos.png',
  imageAltText: 'Nandos Logo',
  defaultLink: 'https://www.nandos.com.au/menu',
};

const DeliveryOptionsBlock = ({ deliveryServices, orderingEnabled, hasBackgroundDecal }) => {
  const items = map(values(deliveryServices), (option, index) => {
    const service = keys(deliveryServices)[index];
    return {
      heading: options[service].description,
      externalLink: option.link || options[service].defaultLink,
      image: [
        {
          url: options[service].imageSrc,
          alt: options[service].imageAltText,
        },
      ],
    };
  });

  if (orderingEnabled) {
    items.unshift({
      heading: nandosOption.description,
      externalLink: nandosOption.defaultLink,
      image: [
        {
          url: nandosOption.imageSrc,
          alt: nandosOption.imageAltText,
        },
      ],
    });
  }

  return (
    <LinkCardBlock
      heading="Need delivery? We’ve got you covered"
      linkCardItems={items}
      hasBackgroundDecal={hasBackgroundDecal}
    />
  );
};

DeliveryOptionsBlock.propTypes = {
  deliveryServices: PropTypes.shape({
    uberEats: PropTypes.shape({
      live: PropTypes.bool,
      link: PropTypes.string,
    }),
    menulog: PropTypes.shape({
      live: PropTypes.bool,
      link: PropTypes.string,
    }),
    doorDash: PropTypes.shape({
      live: PropTypes.bool,
      link: PropTypes.string,
    }),
  }).isRequired,
  orderingEnabled: PropTypes.bool.isRequired,
  hasBackgroundDecal: PropTypes.bool.isRequired,
};

export { DeliveryOptionsBlock };
